export default {
  common: {
    loading: 'Cargando...',
    noData: 'Sin datos disponibles.',
  },
  nav: {
    home: 'Inicio',
    products: 'Producto',
    about: 'Nosotros',
    partnership: 'Asociación',
    blog: 'Blog',
  },
  home: {
    text: 'INICIO',
    title: 'YOOXPLORE',
    hero: {
      title1: 'Empoderando a Socios Globales',
      title2: 'Asegurando el Futuro desde el Aire',
      bookDemo: 'Reservar Demo',
    },
  },
  overview: {
    title: 'Descripción General',
    subtitle: 'Plataforma UAV YOOX S3T',
    content: 'El YOOX S3T es un vehículo aéreo no tripulado (UAV) avanzado capaz de levantar cargas pesadas, volar de manera estable y maniobrar con gran precisión. Diseñado para ser uno de los mejores drones autónomos del mercado, destaca por su larga duración de vuelo y su excepcional rendimiento de largo alcance, ideal para operaciones militares, tareas industriales y misiones humanitarias.',
    content2: 'Además de vender drones, ayudamos a que tu marca de drones tenga éxito localmente. Proporcionamos soluciones de producción y ensamblaje localizadas, ayudándote a construir tu propio sistema de producción para alcanzar tus objetivos.',
  },
  scenarios: {
    title: 'Escenarios',
    subtitle: 'Ampliable a más casos de uso industrial',
  },
  advantages: {
    title: 'Ventajas Principales',
    subtitle: 'Diseñado para escalar según tus necesidades',
  },
  products: {
    title: 'Centro de Productos',
    intro: 'Introducción de Productos',
    subtitle: 'Plataformas de Vuelo de Nivel Industrial y Productos Ecológicos',
    gallery: {
      all: 'Todo',
    },
    contact_business: 'Por favor contáctenos para más detalles del producto',
  },
  about: {
    text: 'Nosotros',
    title: 'Sobre Nosotros',
    teamTitle: 'Nuestro Equipo',
    teamSubtitle: 'De empresas líderes globales',
    teamContent: 'Nuestro equipo proviene de empresas como DJI, Yamaha, Apple, Tesla, etc. Tenemos un promedio de más de diez años de experiencia en la industria de drones, así como en los campos de seguridad y defensa.',
    visionTitle: 'Nuestra Visión',
    visionSubtitle: 'Ayudamos a que tu marca de drones tenga éxito localmente',
    visionContent: 'Además de vender drones, proporcionamos soluciones de producción y ensamblaje localizadas, ayudándote a construir tu propio sistema de producción para fabricar los mejores drones y alcanzar tus objetivos.',
  },
  partnership: {
    title: 'Asociación',
    primaryCta: 'Al por mayor & ODM & OEM',
    secondaryCta: 'Conviértete en Distribuidor',
    qaTitle: 'Preguntas Frecuentes',
  },
  blog: {
    title: 'Blog',
    heading: 'Perspectivas y Actualizaciones',
    subheading: 'Lo último en drones, localización y tendencias del mercado.',
    searchPlaceholder: 'Buscar artículos',
  },
  contact: {
    title: 'Contáctenos',
    title2: 'Nos encantaría saber de usted.',
    content1: 'Si desea más información o cooperar con nosotros, contáctenos por WhatsApp, Telegram o el formulario.',
    whatsappLabel: 'WhatsApp',
    whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
    telegramLabel: 'Telegram',
    telegramValue: 'Telegram: <YOUR_TELEGRAM>',
    form: {
      title: 'Formulario de Contacto',
      subtitle: 'Nos encantaría saber de usted.',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      company: 'Empresa',
      country: 'País/Región',
      interestLabel: 'Estoy interesado en',
      interests: ['Compra de productos', 'Convertirse en distribuidor', 'OEM/ODM', 'Consulta técnica', 'Otro'],
      message: 'Sus necesidades y descripción',
      submit: 'Enviar',
      submitTip: 'Gracias por contactarnos. Le responderemos en breve.',
      submitError: 'Envío fallido. Por favor intente de nuevo.',
    },
  },
}
